/**
 * List of options for the RFID Reader types field
 *
 * - `ports` defines the maximum number of antennas for a reader of this type
 * - `tagType` must be one of {@link tmrTagTypes}
 *
 * @namespace tmrRfidReaderTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrRfidReaderTypes',
  {
    ImpinjSpeedwayOctaneDto: {
      label: 'Impinj Speedway Octane',
      ports: 4,
      tagType: 'UHF',
    },
    ImpinjXArrayDto: {
      label: 'Impinj XArray',
      ports: 52,
      tagType: 'UHF',
    },
    CaenSlateDto: {
      label: 'Caen Slate',
      ports: 1,
      tagType: 'UHF',
    },
    CaenQuattroDto: {
      label: 'Caen Quattro',
      ports: 4,
      tagType: 'UHF',
    },
    NordicidSampoLabidDto: {
      label: 'Nordic ID Sampo LabId',
      ports: 1,
      tagType: 'UHF',
    },
    NordicidSampoNativeDto: {
      label: 'Nordic ID Sampo Native',
      ports: 1,
      tagType: 'UHF',
    },
    FeigRfidReaderDto: {
      label: 'Feig NFC',
      ports: 1,
      tagType: 'NFC',
    },
    ZebraReaderDto: {
      label: 'Zebra FX Series',
      ports: 8,
      tagType: 'UHF',
    },
    KitnloLabidDto: {
      label: 'Kit NLO LabId',
      ports: 1,
      tagType: 'NFC',
    },
    TmrEmulatorDto: {
      label: 'Stylewhere Emulator',
      ports: 1,
      tagType: 'UHF',
    },
  },
]
